import WidgetService from '../dashboard/WidgetService.js';
import Emitter from '../core/Emitter.js'
import Model from './Model.js';
import Utility from '../core/Utility.js';

class AbstractWidget extends Emitter {
	constructor(ctx, store) {
		super();
		this.ctx = ctx;
		this.store = store;
		this.isActive = false;

		this.service = WidgetService.get(this.ctx.type);

		this.isCustomQueryWidget = this.service.constructor.CUSTOM || false;
		this.isStreamQueryWidget = this.service.constructor.STREAM || false;
		this.isPersistentWidget = this.service.constructor.PERSIST || false;

		if(!!ctx.data.source) {
			this.model = new Model(store.sources[ctx.data.source.guid], ctx.data.query
				|| ctx.data.source.subcommand, this.datasourceChangeHandler.bind(this), this.isStreamQueryWidget); // legacy
		}
		else {
			this.model = new Model(null, ctx.data.query, undefined, this.isStreamQueryWidget);
		}

		// this.store = store;
		this.interval = ctx.interval * 1000 || 5000;
		// console.log(ctx.interval, this.interval)

		this.guid = ctx.guid;

		this.limit = this.service.constructor.MAX || 1000;
		this.columns = ctx.columns || [];
		this.isRefreshing = false;
	}

	datasourceChangeHandler(event){
		console.log('handleFilterChanged', this.model.toString(), this.model.query);
		if(!!this.isActive){
			this._restart();
		} else {
			this.refreshStart();
		}
		
		// #2711 
		if(this.rendered && typeof this.rendered.zoomOut === 'function') {
			this.rendered.zoomOut();
		}
		//this.model._removeQuery(this.model._runQuery.bind(this.model));
	}

	checkDataSource(){
		if(!!this.ctx.data.source && this.ctx.data.source.guid){ // context에 source가 있는경우.
			if(!this.store.sources[this.ctx.data.source.guid]){//guid가 있다면 property edit에서 삭제되었을 경우. 그외 정상적으로 바뀐경우는 contextupdate를 탄다.
				this.model.update(null, this.ctx.data.query);
				this.ctx.data.source.guid = null;
			}
		}
	}

	_restart(){
		if(!this.isActive){
			return;
		}
		this._suspend(this._resume.bind(this));
	}

	_resume() {
		this.isActive = true;
		if(this.rendered && typeof this.rendered.onPause === 'function') {
			this.rendered.onPause(this.isActive);
		}
		return this._request();
	}

	suspend() {
		this._suspend();
	}

	_suspend(restartCallback) {
		this.isActive = false;
		if(this.rendered && typeof this.rendered.onPause === 'function') {
			this.rendered.onPause(this.isActive);
		}
		if(this.isStreamQueryWidget){
			if(!!this.timer){
				clearTimeout(this.timer);
				this.timer = null;
			}
		} else {
			this._stopTimer();
		}
		this.model.stopRequest(restartCallback);
		//this.unRegisterEventAll();
	}

	registerEventAll(start , eof, rows, failed){
		this.registerEvent('started' , start);
		this.registerEvent('eof' , eof);
		this.registerEvent('rows', rows);
		this.registerEvent('failed', failed);
	}

	registerEvent(eventName , handler){
		if(!!eventName != null && !!handler != null){
			$(this.model).off( `${eventName}.${this.guid}`).on( `${eventName}.${this.guid}`, handler);
		}
	}

	unRegisterEventAll(){
		this.unRegisterEvent('started');
		this.unRegisterEvent('eof');
		this.unRegisterEvent('rows');
		this.unRegisterEvent('failed');
	}

	unRegisterEvent(eventName){
		$(this.model).off( `${eventName}.${this.guid}`);
	}

	streamQueryCallback(jQueryEvent){
		this.endedAt = new Date();
		this.ellapsed = Math.abs(this.endedAt - this.startedAt);
		this.startedAt = this.endedAt;
		this.latestData = jQueryEvent.originalEvent.resp.rows;
		this.columns = Utility.getColumnType(this.latestData);
		// if(!!jQueryEvent.detail){
		// 	this.columns = this.convertColumnObjectToArray(jQueryEvent.detail.field_types);
		// }
		if(this.latestData !== undefined){
			this.renderContainer(this.latestData);
		}
	}

	convertColumnObjectToArray(data){
		var array = data;
		if(!Array.isArray(data)){
			array = [];
			var keys = Object.keys(data);
			keys.forEach(function(key){
				var type = undefined;
				if(data[key] === 'int' ||data[key] === 'long' || data[key] === 'short' || data[key] === 'double' || data[key] === 'float' ){
					type = 'number';
				} else if(data[key] === 'ipv4' ||data[key] === 'ipv6'){
					type = 'ip';
				} else if(data[key] === 'date'){
					type = 'datetime';
				} else {
					type = data[key];
				}
				array.push({
					key:key,
					type:type
				});
			})
		}
		return array;
	}

	_request() {
		if(this.isActive) {
			if(this.isStreamQueryWidget){
				this.endedAt = new Date();
				this.renderContainer([]);
				
				this.registerEventAll(
					(jqueryEvent) => {
						this.startedAt = new Date();
						this.ellapsed = null;
						this.renderLoading(this.latestData || []);
						this.service.onQueryStart();
					}, 
					(jqueryEvent) => {
						this.streamQueryCallback(jqueryEvent);
						this.model.stopRequest(); // eof가 사용자때문에 생성된것인지 query가 끝나서 eof 가 온것인지 모르기 때문에 항상 실행해 줘야한다.
						this.service.onQueryEnd();

						if(!!this.isActive){ // restart시, 스트림 쿼리는 suspend 후에 resume을 하게 하여 timer가 돌지 않게 함.
							this.timer = setTimeout( ()=>{
									this.endedAt = new Date();
									this.renderContainer(this.latestData || []);
									this.model.request();
								},1000
							);
						}
					},
					(jqueryEvent) =>{
						this.streamQueryCallback(jqueryEvent);
						this.renderLoading(this.latestData || []);
					},
					this.onFailed.bind(this)
				);

				this.model.request();
				
			} else {
				this.registerEventAll(
					this.onDataRequested.bind(this), 
					(e) => {
						this.model.getResult(0, this.limit, !!e.originalEvent.isFiltered);
					},
					this.onDataArrived.bind(this),
					this.onFailed.bind(this)
				);

				if(!this.isTimerRunning) { // 최초시작시에 타이머가 활성화 되지 않으므로 최초1회 수동시작 시작해줌.
					// 쿼리를 실행하기전에 이벤트 핸들러를 등록하는게 맞을것으로 보임.
					this.requestQueryRunning();
				}
			}
		}
		else {
			// console.warn('--- resume but dont request ', this.ctx.name);
			this._runTimer();
			
		}
		return true;
	}

	refreshStart(){
		if(this.isStreamQueryWidget){
			return;
		}
		//the widget using stream query don't need to  use refrsh.
		if(this.refreshTimer) {
			clearTimeout(this.refreshTimer);
		}

		if(!!this.isRefreshing){
			return;
		}

		this.isRefreshing = true;
		
		if(!!this.isActive){
			this._stopTimer();
			this.model.stopRequest();
			this.unRegisterEventAll();
		} 	
		this.model.clearAfterQueryString();		
		this.registerEventAll(
			this.onDataRequested.bind(this), 
			(e) => {
				this.model.getResult(0, this.limit, !!e.originalEvent.isFiltered);
			},
			this.onRefreshDataArrived.bind(this), // batch query와 data가 도착했을때의 handler만 다름.
			this.onFailed.bind(this)
		);
		this.requestQueryRunning();
	}

	refreshEnd(){
		if(!this.isRefreshing || this.isStreamQueryWidget){
			return; // refreshStart와 pair로 동작해야한다.
		}
		this.model.stopRequest();
		this.unRegisterEventAll();
		if(!!this.isActive){ // refresh 하는동안 suspend를 눌렀을 경우 timing 버그가 생길 수 있음.
			// refresh에서의 resume은 interval이후에 실행되어야 함(그렇지 않으면 refresh 후 바로 resume이 실행되어 event를 다시 등록하고 data를 바로 쿼리함)
			this.refreshTimer = setTimeout( () => {	
				this._resume();
				//this._runTimer();
			}, this.interval);
		}
		this.isRefreshing = false;
	}

	refreshOld() {
		console.warn('--- request ', this.ctx.name);
		this.model.request();
		this._stopTimer();
		this._runTimer();
	}

	updateContext(context) {
		// this.ctx.name = context.name || this.ctx.name;
		var hasToRestart = false;
		if(!!this.isActive){
			if(!this.isStreamQueryWidget){ // nomal 위젯인 경우
				this._suspend();
			}
			hasToRestart = true;
		}

		if(!!context.data.source) {
			this.model.update(this.store.sources[context.data.source.guid], context.data.query);
		}
		else {
			this.model.update(null, context.data.query);
		}


		this.ctx = context;
		this.interval = context.interval * 1000;

		if(hasToRestart){
			if(!this.isStreamQueryWidget){
				this._resume();
			} else {
				this._restart(); // stream인 경우 stop start를 동기화 시켜서 시작해야하기 때문에 restart 해야함.
			}
		} else {
			if(!this.isStreamQueryWidget){
				this.refreshStart(); // 스트림 위젯과 사용자 정의 위젯은 refresh가 없음.
			}
		}

		this.dispatchEvent(new Event('modify'));
	}

	setTheme(param) {
		this.theme = param;
	}

	_runTimer() {
		if(!this.isActive){
			return;
		}
		this.isTimerRunning = true;
		this.timer = setTimeout(() => {
			this._stopTimer();
			//this._request(this);
			this.requestQueryRunning();
		}, this.interval);
	}

	requestQueryRunning(){
		this.checkDataSource();
		this.model.request();
		this.startedAt = new Date();
		// 데이터 요청 시작시 인디케이터 보여준다.(처음 시작시 ellapsed는 null);
		this.renderLoading(this.latestData || []); // #2603 로딩 인디케이터 표시 위해 다시 주석 해제했음
	}

	_stopTimer() {
		this.isTimerRunning = false;
		if(!!this.timer) {
			clearTimeout(this.timer);
			this.timer = null;
		}
	}

	onDataArrived(e) {
		this._runTimer();

		// console.log(e.detail)
		if(Array.isArray(e.detail.result)) {
			//this.columns = Utility.getColumnType(e.detail.result);
			this.columns = this.convertColumnObjectToArray(e.detail.field_types);
		}
	}

	handleRefreshDataArrived(e) {
		//console.log(e.detail)
		if(Array.isArray(e.detail.result)) {
			//this.columns = Utility.getColumnType(e.detail.result);
			this.columns = this.convertColumnObjectToArray(e.detail.field_types);
		}
		this.refreshCallback();
		this.refreshEnd();
	}

	onDataRequested(resp) {

	}

	onModelDestroyed() {
		this.model = null;
	}

	onFailed(e) {

	}
}

export default AbstractWidget;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/data/AbstractWidget.js